import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { ListItemText, Typography } from '@material-ui/core';
import variables from '../../../Sys/variable.scss';

const useStyles = makeStyles((theme) => ({
    menuItemText: {
        color: "#fff",
        fontSize: '0.875rem',
        '&.MuiTypography-body1': {
            color: "#fff",
            fontSize: '0.875rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8125rem',
            '&.MuiTypography-body1': {
                fontSize: '0.8125rem',
            },
        },
    },
    darkThemeColor: {
        color: variables.darkThemeText,
        fontSize: '0.875rem',
        '&.MuiTypography-body1': {
            color: variables.darkThemeText,
            fontSize: '0.875rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8125rem',
            '&.MuiTypography-body1': {
                fontSize: '0.8125rem',
            },
        },
    },
}));

const MenuItems = ({ submenus, handleItemClick, location }) => {
    const classes = useStyles();
    return (
        <ul className="dropdown">
            {submenus.map((submenu, index) => {
                const isSelected = location.pathname.startsWith(submenu.active) || false;
                return (
                    <ListItem
                        data-testid={`sidebar-item-${submenu.title.toLowerCase().replace(/\s+/g, '-')}`}
                        onClick={() => handleItemClick(submenu.active)}
                        style={{ marginBottom: 10, ...(isSelected && {backgroundColor: variables.sidebarActive}) }}
                        selected={isSelected}
                        button
                        key={index}
                    >
                        <ListItemIcon className={isSelected ? classes.menuItemText : classes.darkThemeColor }>{submenu.icon}</ListItemIcon>
                        <ListItemText primary={<Typography className={isSelected ? classes.menuItemText : classes.darkThemeColor }>{submenu.title}</Typography>} />
                    </ListItem>
                );
            })}
        </ul>
    );
}

export default MenuItems;